var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-card p-6"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Trạng thái"}},[_c('SettingStatus')],1),_c('vs-tab',{attrs:{"label":"Nhãn công việc"}},[_c('SettingLabel')],1),_c('vs-tab',{attrs:{"label":"Cấp độ ưu tiên"}},[_c('SettingPriority')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }